/**
 * State detection utilities for drawer and BAB elements
 */

/**
 * Check if activity card drawer is open (excludes HoveringPortal drawers)
 */
export function checkDrawerState(mutations = null) {
  let hasOpenDrawer = false;

  if (mutations) {
    hasOpenDrawer = checkMutationsForDrawer(mutations);
  }

  if (!hasOpenDrawer) {
    hasOpenDrawer = checkDOMForOpenDrawer();
  }

  return hasOpenDrawer;
}

function checkMutationsForDrawer(mutations) {
  for (const mutation of mutations) {
    if (checkAttributeMutation(mutation) || checkChildListMutation(mutation)) {
      return true;
    }
  }
  return false;
}

function checkAttributeMutation(mutation) {
  if (mutation.type !== 'attributes' || mutation.attributeName !== 'class') {
    return false;
  }

  const element = mutation.target;
  return isDrawerOpen(element) && !isHoveringPortalDrawer(element);
}

function checkChildListMutation(mutation) {
  if (mutation.type !== 'childList') return false;

  for (const node of mutation.addedNodes) {
    if (node.nodeType !== Node.ELEMENT_NODE) continue;

    const element = node;
    if (hasDrawerOpenClass(element) && !isHoveringPortalDrawer(element)) {
      return true;
    }
  }
  return false;
}

function isDrawerOpen(element) {
  return (
    element.classList?.contains('drawer--open') ||
    element.className?.includes('drawer--open')
  );
}

function hasDrawerOpenClass(element) {
  return (
    element.classList?.contains('drawer--open') ||
    element.className?.includes('drawer--open') ||
    element.querySelector?.('[class*="drawer--open"]')
  );
}

function checkDOMForOpenDrawer() {
  const openDrawers = document.querySelectorAll('[class*="drawer--open"]');
  for (const drawer of openDrawers) {
    if (!isHoveringPortalDrawer(drawer)) {
      return true;
    }
  }
  return false;
}

/**
 * Check if element is a HoveringPortal drawer
 */
function isHoveringPortalDrawer(element) {
  if (!element) return false;

  const className = element.className || '';

  return (
    className.includes('hovering-portal') ||
    className.includes('drawer--right') ||
    className.includes('drawer--left')
  );
}

/**
 * Check if BAB (Bulk Actions Bar) is visible
 */
export function checkBABState(mutations) {
  let isVisible = false;

  if (mutations) {
    for (const mutation of mutations) {
      const element = mutation.target;
      if (
        element.className?.includes('bulk-action') ||
        element.className?.includes('selected-activities')
      ) {
        const htmlElement = element;
        if (htmlElement.offsetParent !== null) {
          isVisible = true;
          break;
        }
      }
    }
  }

  if (!isVisible) {
    const babElement = document.querySelector(
      '.bulk-actions-bar, [class*="bulk-action"], [class*="selected-activities"]'
    );
    isVisible = babElement && babElement.offsetParent !== null;
  }

  return isVisible;
}

/**
 * Check if mutations contain relevant changes for drawer or BAB
 */
export function hasRelevantChanges(mutations) {
  let hasDrawerChanges = false;
  let hasBABChanges = false;

  for (const mutation of mutations) {
    const target = mutation.target;
    const className = target.className || '';

    if (className.includes('drawer') || className.includes('Drawer')) {
      hasDrawerChanges = true;
    }
    if (
      className.includes('bulk') ||
      className.includes('action') ||
      className.includes('selected')
    ) {
      hasBABChanges = true;
    }

    if (hasDrawerChanges && hasBABChanges) break;
  }

  return { hasDrawerChanges, hasBABChanges };
}
